import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Marketdate } from './marketdate.model';
import { MarketdatePopupService } from './marketdate-popup.service';
import { MarketdateService } from './marketdate.service';

@Component({
    selector: 'jhi-marketdate-delete-dialog',
    templateUrl: './marketdate-delete-dialog.component.html'
})
export class MarketdateDeleteDialogComponent {

    marketdate: Marketdate;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private marketdateService: MarketdateService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketdate', 'marketStatus']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.marketdateService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'marketdateListModification',
                content: 'Deleted an marketdate'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-marketdate-delete-popup',
    template: ''
})
export class MarketdateDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketdatePopupService: MarketdatePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.marketdatePopupService
                .open(MarketdateDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate/marketdate-delete-dialog.component.ts